import React, { useState } from 'react';
import {
  Modal,
  Label,
  TextInput,
  Textarea,
  Button,
} from 'flowbite-react';

const EMOJI_OPTIONS = ["🤖", "🎯", "🎨", "📊", "✍️", "📅", "💡", "🔧", "🎮", "📱"];

const CustomSidekickForm = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    title: '', // Change 'name' to 'title'
    icon: '🤖',
    description: '',
    customPrompts: []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...formData,
      id: `custom-${Date.now()}`,
      isCustom: true
    });
    onClose();
  };

  return (
    <Modal show={isOpen} onClose={onClose}>
      <Modal.Header>
        Create Custom Sidekick
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <Label>Sidekick Title</Label> {/* Update label */}
              <TextInput
                required
                value={formData.title} // Use 'title' here
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="Enter sidekick title" // Update placeholder
                className="w-full"
              />
            </div>

            <div>
              <Label>Choose Icon</Label>
              <div className="flex flex-wrap gap-2">
                {EMOJI_OPTIONS.map((emoji) => (
                  <button
                    key={emoji}
                    type="button"
                    onClick={() => setFormData({ ...formData, icon: emoji })}
                    className={`p-2 text-2xl rounded hover:bg-gray-100 ${
                      formData.icon === emoji ? 'bg-gray-200' : ''
                    }`}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <Label>Description</Label>
              <Textarea
                required
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Describe your sidekick's capabilities"
                className="w-full"
              />
            </div>

            <div>
              <Label>Custom Prompt (Optional)</Label>
              <Textarea
                value={formData.customPrompt}
                onChange={(e) => setFormData({ ...formData, customPrompt: e.target.value })}
                placeholder="Enter any specific instructions or context for your sidekick"
                className="w-full"
              />
            </div>

            <div className="flex justify-end space-x-2">
              <Button color="gray" onClick={onClose}>
                Cancel
              </Button>
              <Button color="gray" type="submit" className='text-gray-900'>
                Create Sidekick
              </Button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CustomSidekickForm;